export const OutOfStateBannerWrapper = {
  marginBottom: '$md',
  '@media (max-width: 1268px)': {
    width: '20%',
  },
  '@screen < $xl': {
    width: '94%',
  },
};
